import { useAppDispatch, useAppSelector } from 'app/hooks';
import { syncPtacConfigurations } from 'features/configurations';
import useEnsureAnchorExistingSystemOfType from 'hooks/use-ensure-anchor-existing-system-of-type';
import useIsPtacPathway from 'hooks/use-is-ptac-pathway';
import { useEffect } from 'react';
import { collectPtacRooms } from 'utils/ptac-configuration';
import { isSystemDesignStageTab } from 'utils/system-design-stage-tabs';

type PtacConfigurationWatcherProps = {
  loading: boolean;
};

export default function PtacConfigurationWatcher({
  loading
}: PtacConfigurationWatcherProps) {
  const dispatch = useAppDispatch();
  const isPtac = useIsPtacPathway();
  const configurations = useAppSelector(
    (state) => state.configurations.configurations
  );
  const onDesignTab = useAppSelector((state) =>
    isSystemDesignStageTab(state.ui.activeTab)
  );
  const roomsKey = useAppSelector((state) =>
    JSON.stringify(
      collectPtacRooms(state.structure.structure).map(({ space, level }) => [
        level.uniqueId,
        space.uniqueId,
        space.label,
        space.BTUs,
        space.position,
        space.width,
        space.length
      ])
    )
  );

  useEnsureAnchorExistingSystemOfType(!loading && isPtac ? 'ptac' : null);

  useEffect(() => {
    if (loading || !isPtac || !onDesignTab) return;
    dispatch(syncPtacConfigurations());
  }, [loading, isPtac, onDesignTab, roomsKey, configurations, dispatch]);

  return null;
}
